import React, { FC, useMemo } from 'react'
import { Spinner } from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import { FormLayoutContent, FormLayout } from 'components/FormLayout';
import { Operation } from 'data/types'
import useFqdn from '../../hooks/useFqdn'
import useDomainForm from '../../hooks/useDomainForm'
import { FqdnFormHeader } from '../../components/FqdnFormHeader'
import { FqdnDomainFormGrid } from '../../components/FqdnDomainFormGrid'

export const FqdnEdit: FC = () => {
    const { t } = useTranslation()
    const { items, isLoading, selectedItem } = useFqdn()

    const domainNamesInitalValue = useMemo(() => (
        items.filter(({ fsId: groupName }) => groupName === selectedItem?.fsId)
             .map(({ id, domainName }, index) => ({
                id, index, domainName, operation: 'NO_OPERATION' as Operation
              }))
    ), [items, selectedItem?.fsId])

    const {
      domainNames, domainGroup, setDomainGroup, handleClickSave, handleCellValueChanged, handleClickAddDomainItem, handleClickRemoveDomainItem
    } = useDomainForm({ domainGroup: selectedItem?.fsId, domainNames: domainNamesInitalValue })

    return (
      <div data-testid="FqdnEdit">
        <FormLayout>
          <FormLayoutContent>
            {isLoading && <Spinner aria-label="Loading..." />}
            {!isLoading && (
            <React.Fragment>
              <FqdnFormHeader title={t('fqdn.grid.editItemTitle')} onClickSave={handleClickSave} />
              <FqdnDomainFormGrid
                domainGroup={domainGroup}
                setDomainGroup={setDomainGroup}
                domainNames={domainNames.filter(({ operation }) => operation !== 'DELETE')}
                onCellValueChanged={handleCellValueChanged}
                onClickAddDomainItem={handleClickAddDomainItem}
                onClickRemoveDomainItem={handleClickRemoveDomainItem}
              />
            </React.Fragment>
            )}
          </FormLayoutContent>
        </FormLayout>
      </div>
    )
}

export default FqdnEdit;
